import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { ModalButton } from 'src/components/Global/Button/Button'
import { useTypedSelector } from 'src/redux/index'
import { AutomatedWrapper, CheckoutWrapper, PaymentWrapper } from './style'
import PaymentSelect from 'src/components/Payment/PaymentSelect/PaymentSelect'
import { joinContestAction } from 'src/redux/actions/xcontest'
import useSnackbar from 'src/hooks/useSnackBar'
import XContestSuccess from '../Success/XContestSuccess'
import { Spinner } from 'src/components/Global/Spinner/Spinner'

const ContestCheckout = () => {
  const joinForm = useTypedSelector((state) => state.xcontest.joinForm)
  const snackbar = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [title, setTitle] = useState<string>('')

  const {
    contest_id,
    saving_type,
    saving_frequency,
    // maturity_date,
  } = joinForm

  const maturityDate = new Date(joinForm.maturity_date).toDateString()
  const startDate = new Date(joinForm?.start_date).toDateString()

  console.log(joinForm)

  const allContest = useTypedSelector((state) => state.xcontest.all)
  const singleContest = allContest.filter(
    (item: any) => item?.id === contest_id
  )

  const { name } = singleContest[0]

  const dispatch = useDispatch()

  const handleDispatch = () => {
    dispatch(joinContestAction({ joinForm, onSuccess, onError }))
    setLoading(true)
  }

  const onSuccess = (data: any) => {
    console.log(data)
    setTitle(data)
    setLoading(false)
    setShowSuccessModal(true)
    snackbar.trigger({
      message: data,
      severity: 'success',
    })
  }

  const onError = (error: any) => {
    console.log(error)
    setLoading(false)
    snackbar.trigger({
      message: error,
      severity: 'error',
    })
  }

  const [option, setOption] = useState({
    name: 'card',
    data: '',
  })

  return (
    <CheckoutWrapper>
      <AutomatedWrapper>
        <div className="header">
          <h3>{name}</h3>
          <p>Here is a quick review of your {name}</p>
        </div>
        <div className="flex_container">
          <div className="flex_one">
            <p>Saving type</p>
            {saving_type === 'automated' ? <p>Saving frequency</p> : ''}
            <p>Start date</p>
            <p>Maturity date</p>
          </div>
          <div className="flex_two">
            <p>{saving_type}</p>
            {saving_type === 'automated' ? <p>{saving_frequency}</p> : ''}
            <p>{startDate}</p>
            <p>{maturityDate}</p>
          </div>
        </div>
        <PaymentWrapper>
          {saving_type === 'automated' && (
            <PaymentSelect option={option} setPayWithMethod={setOption} />
          )}
        </PaymentWrapper>
      </AutomatedWrapper>
      <div className="btn_container">
        <ModalButton onClick={handleDispatch} className="proceed_btn">
          Proceed {loading && <Spinner />}
        </ModalButton>
      </div>
      <div className="modal_wrapper">
        <XContestSuccess showSuccessModal={showSuccessModal} title={title} />
      </div>
    </CheckoutWrapper>
  )
}

export default ContestCheckout
